var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterIcon = function SvgFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    fillRule: "evenodd",
    d: "M19.01 3.96V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v.96h-11v2h11V7c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V5.96H22v-2zm-2 2.04h-2V4h2zm-1 11c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v.96h-8v2h8V21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1.04H22v-2h-5.99zm-4 3v-2h2v2zm-3-11c.55 0 1 .45 1 1v.96H22v2H10.01V14c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1v-1.01L2 12.97l.02-2 1.99.02V10c0-.55.45-1 1-1zm-3 4h2v-2h-2z",
    clipRule: "evenodd"
  })));
};
export { SvgFilterIcon as Icon };
export default __webpack_public_path__ + "static/media/dfd0ea4807e82b0f4762ad44fe74b443.svg";